import React from 'react';
import '../index.scss'
import { connect } from 'react-redux'
import { friendsLocationMapObj } from '../../../../../action/friends-location-action';
import { shareLocationRequest } from '../../../../../action/location-sharing-actions';
import { infoWindowOpenAction } from '../../../../../action/infowindow-action';
import ImageUrl from '../../../../../../asset/Avatar_BaseMap-User_Default@1x.png'

class FriendCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      imageUrl: '../../../../../../asset/Avatar_BaseMap-User_Default@1x.png',
    };
  }

  componentDidMount() {
    this.checkImage(this.props.user.imageProfileUrl);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.user.imageProfileUrl !== this.props.user.imageProfileUrl) {
      this.checkImage(this.props.user.imageProfileUrl);
    }
  }

  componentWillUnmount() {
    this.advanceMarker ? this.advanceMarker.map = null : ''

  }

  buildContent = (url, color) => {
    let colorMarker = color
    const content = document.createElement("div");
    content.classList.add("photo-property");
    content.innerHTML = `
      <div style="height: 30px; width: 30px; border: 2px solid ${colorMarker}; border-radius: 50%; overflow: hidden;margin-bottom: 5px; position: relative;background-color: ${colorMarker}">
      <img style="height: 30px; width: 30px; object-fit: cover; position: absolute; top: 0; left: 0;" src="${url ? url : ImageUrl}" alt="Image">
      </div>
      <div class="triangle-style-mouse-handler" style="border-top: 13px solid ${colorMarker}" ></div>
    `
    return content;
  }

  friendLocation(imageUrl, imageBgColor, position, userData) {
    const { mapReference, friendsLocationMapObjState, infoWindow, infoWindowOpenAction } = this.props;
    let existingFriend = friendsLocationMapObjState.find(item => userData.id === item.friendId);

    // if (infoWindow.infoWindowFunction) {
    //   infoWindow.infoWindowFunction.close();
    //   infoWindowOpenAction(null)
    // }

    if (existingFriend) {
      let markerObject = existingFriend.mapObject
      markerObject.position = { lat: position.latitude, lng: position.longitude }
      mapReference.setCenter({ lat: position.latitude, lng: position.longitude });
      mapReference.setZoom(12)
    } else {
      // If the friend does not exist, create a new marker
      const createMarkerFunction = async () => {
        let { AdvancedMarkerElement } = await window.google.maps.importLibrary("marker");
        let markerOptions = {
          map: mapReference,
          position: { lat: position.latitude, lng: position.longitude },
          content: this.buildContent(imageUrl, imageBgColor),
        };
        this.advanceMarker = new AdvancedMarkerElement(markerOptions);

        let inserData = { friendId: userData.id, mapObject: this.advanceMarker }
        this.props.friendsLocationMapObj([...friendsLocationMapObjState, inserData]);
        mapReference.setCenter({ lat: position.latitude, lng: position.longitude });
        mapReference.setZoom(12)
        this.advanceMarker.addListener('click', () => {
          this.advanceMarker.map = null
        });
      };
      if (position) {
        createMarkerFunction();
      } else {
      }
    }
  }

  checkImage(imageUrl) {
    if (!imageUrl) {
      this.setState({
        imageUrl: '../../../../../../asset/Avatar_BaseMap-User_Default@1x.png',
      });
      return;
    }

    const img = new Image();
    img.src = imageUrl;

    img.onload = () => {
      this.setState({ imageUrl });
    };

    img.onerror = () => {
      this.setState({
        imageUrl: '../../../../../../asset/Avatar_BaseMap-User_Default@1x.png',
      });
    };
  }

  loactionShare() {
    let lat = 0,
      long = 0
    this.props.shareLocationRequest(lat, long)
  }
  render() {
    const { user, friendLocations } = this.props;
    const { imageUrl } = this.state;

    return (
      <div key={user.id} className="friend-card-base">
        <img className="friend-card-profile-image" src={imageUrl} alt="User profile" />
        <div className="container-name-text">
          <p className="friend-card-name" title={user.fullName}>
            {user.fullName}
          </p>
          <p className="not-sharing-location">
            {user.sharingLocationWithMe ? 'Sharing Location' : 'Not Sharing Location'}
          </p>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            height: 65,
            width: 90,
            position: 'relative',
            bottom: user.sharingLocationWithMe ? 10 : '',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            top: user.sharingLocationWithMe && user.sharingLocationWithThem && friendLocations ? '-6px' : '50%'
          }}
        >
          {user.sharingLocationWithMe && (
            user.sharingLocationWithThem && friendLocations ?
              <button
                className="friend-card-view-location-button"
                onClick={() => {
                  let color = '#589500';
                  this.friendLocation(user.imageProfileUrl, color, user.userLocation, user);
                }}
              >
                View Location
              </button>
              : null
            // <div className='error-symbol-container' onClick={() => {
            // this.loactionShare()
            // alert('Share your location with your friend to view his location')
            // }}>
            //  <p className='error-symbol'></p>
            // </div>
            // <p>Share Your locationto view friendlocation</p>
          )}
          <button
            className={user.followingThem ? 'friend-card-unfollow-button' : 'friend-card-follow-button-top'}
            onClick={() => {
              if (user.followingThem)
                this.props.unfollowPopup(user)
              else
                this.props.handleFollow((user))
            }}
          >
            {user.followingThem ? 'Unfollow' : 'Follow'}
          </button>
        </div>
      </div >
    );
  }
}

const mapStateToProps = state => ({
  mapReference: state.mapReference(),
  friendsLocationMapObjState: state.friendsLocationMapObj,
  friendsLocationState: state.friendsLocation,
  infoWindow: state.infoWindow
})

const mapDispatchToProps = dispatch => ({
  friendsLocationMapObj: (payload) => { dispatch(friendsLocationMapObj(payload)) },
  shareLocationRequest: (payload) => { dispatch(shareLocationRequest(payload)) },
  infoWindowOpenAction: (payload) => dispatch(infoWindowOpenAction(payload))
})

export default connect(mapStateToProps, mapDispatchToProps)(FriendCard)


